import { getLocale } from '@zenlayer/zen-intl18';
/**
 * 格式化存储单位
 * @function
 * @param {number} v - 要格式化的值
 * @param {string} unit - 单位后缀，作为字符串附加到格式化结果的末尾（可选）
 * @param {number} precision - 指定格式化结果的小数位数(可选)
 * @return {JSX.Element}
 * @example
 * // Returns '1.23 km'
 * unitFormatter(1230, 'm');
 */

export var unitFormatter = function unitFormatter(v, unit) {
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (typeof v !== 'number') {
    return '';
  }

  var result = '';

  var setPrecision = function setPrecision(val) {
    return new Number(val.toFixed(precision));
  };

  if (v >= Math.pow(10, 12)) {
    result = setPrecision(v / Math.pow(10, 12)) + ' T';
  } else if (v >= Math.pow(10, 9)) {
    result = setPrecision(v / Math.pow(10, 9)) + ' G';
  } else if (v >= Math.pow(10, 6)) {
    result = setPrecision(v / Math.pow(10, 6)) + ' M';
  } else if (v >= Math.pow(10, 3)) {
    result = setPrecision(v / Math.pow(10, 3)) + ' K';
  } else {
    result = setPrecision(v) + ' ';
  }

  return unit ? result + unit : result;
};
/**
 * 首字母大写
 * @param str 字符串
 */

export var firstLetterUpperCase = function firstLetterUpperCase(str) {
  if (!str) {
    return '';
  }

  return str.toLowerCase().replace(/^\S/, function (s) {
    return s.toUpperCase();
  });
};
/**
 * 格式化时间周期
 * @function
 * @param {number} n 数量
 * @param {string} unit 单位
 * @return {JSX.Element}
 * @example
 * formatPeriodLabel(1, 'day'); // Returns '1 Day'
 * formatPeriodLabel(24, 'month'); // Returns '2年'
 */

export var formatPeriodLabel = function formatPeriodLabel(n, unit) {
  if ((unit === null || unit === void 0 ? void 0 : unit.toLowerCase()) !== 'month') {
    return "".concat(n, " ").concat(firstLetterUpperCase(unit)).concat(n === 1 ? '' : 's');
  }

  if (n % 12 === 0) {
    var r = n / 12;
    return getLocale() === 'zh' ? "".concat(r, " \u5E74") : "".concat(r, " Year").concat(r > 1 ? 's' : '');
  }

  return getLocale() === 'zh' ? "".concat(n, " \u4E2A\u6708") : "".concat(n, " Month").concat(n > 1 ? 's' : '');
};